import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FieldWrapper } from '@dixa/lib-shared-habla';
import { Component } from 'react';
import Spinner from '../../ajax/components/Spinner';
import ColorPicker from '../colorPicker/ColorPicker';
import styles from './ColorField.module.scss';
export default class ColorField extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        const { label, input, meta, showSpinner, className, onChangeAction } = this.props;
        let spinner = null;
        if (showSpinner === true) {
            spinner = _jsx(Spinner, { className: "dark input" });
        }
        return (_jsx(FieldWrapper, Object.assign({ className: className, label: label, meta: meta }, { children: _jsxs("div", Object.assign({ className: styles.input }, { children: [_jsx(ColorPicker, { color: input.value, onChange: (e) => {
                            if (typeof onChangeAction === 'function') {
                                onChangeAction(e);
                            }
                            input.onChange(e);
                        } }), spinner] })) })));
    }
}
